export default "__VITE_ASSET__mBOW58yS__"